
































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import Api from '@/api/report/orderReport/index'
import { FormItem } from '../../types/iview/form'
@Component({
  components: {
    CustomForm,
  },
})
export default class OrderReconciliation extends AbpBase {
  // filters = [
  //   {
  //     label: '订单编号',
  //     type: 'input',
  //     props: {
  //       placeholder: '请输入订单编号'
  //     },
  //     key: 'tradeNo'
  //   }
  // ]
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '用户名',
      key: 'userName',
      align: 'center',
    },
    {
      title: '地区',
      key: 'area',
      align: 'center',
    },
    {
      title: 'ip地址',
      key: 'clientIpAddress',
      align: 'center',
    },
    {
      title: '登录时间',
      slot: 'creationTime',
      align: 'center',
    },
  ]
  data = []
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  exporting: boolean = false

  mounted() {
    this.loadData()
  }
  submitChange(form, valid) {
    if (valid) {
      console.log(form)
      this.loadData(form)
    }
  }
  loadData(form = {}) {
    Api.getLoginLogData(this.pager.pageSize, this.pager.pageIndex).then(
      (res) => {
        console.log('登录日志', res)
        this.pager.total = res.data.totalCount
        this.data = res.data.items
      }
    )
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    // this.loadData((this.$refs.lineForm as any).form)
    this.loadData()
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    this.pager.pageIndex = 1
    form.submit()
  }
  /**
   * 导出报表
   */
  // exportExcel() {
  //   let refForm: any = this.$refs.lineForm
  //   const form = refForm.getForm()
  //   console.log(form)
  //   Api.exportExcel(this.pager.pageSize, this.pager.pageIndex)
  //     .then((res) => {
  //       this.exporting = false
  //       this.download(res.data)
  //     })
  //     .catch((err) => {
  //       this.exporting = false
  //     })
  // }
  // download(data) {
  //   if (!data) {
  //     return
  //   }
  //   let url = window.URL.createObjectURL(new Blob([data]))
  //   let link = document.createElement('a')
  //   link.style.display = 'none'
  //   link.href = url
  //   link.setAttribute('download', '登录日志报表.xlsx')

  //   document.body.appendChild(link)
  //   link.click()
  // }
}
